/// Menu
import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { masterActions } from "../../../_store";
import { useSelector, useDispatch } from "react-redux";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {}
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const dispatch = useDispatch();

  const currentUser = useSelector((x) => x.auth.user);

  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
  }, []);
  useEffect(() => {
    dispatch(masterActions.GetUserTypeList());
  }, [dispatch]);
  let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;

  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu
  let deshBoard = ["", "dashboard", "order-dashboard"],
    Products = [
      "ProductList",
      "ProductReports",
      "archiveProducts",
      "ProductExpirationReport",
      "TransactionProductReport",
      "TransactionReport",
    ],
    inventory = [
      "StockManagement",
      "inventoryHistory",
      "BulkInventory",
      "MRHistoryReport",
      "MRDiscrepancyReport",
      "MRPurchaseOrderReport",
    ],
    order = [
      "OrderList",
      "AddEditOrder",
      "OrderPreparation",
      "ViewOrder",
      "DispatchDetails",
      "AuditTrailReport",
    ],
    user = ["UserList", "VendorList", "ClientList"],
    master = [
      "CategoriesList",
      "SubCategories",
      "Attributes",
      "Terms",
      "Warehouse",
      "CourierType",
    ],
    settings = ["ChangePassword", "AdminPasscodeSettings"];

  return (
    <div>
      <div
        className={`deznav ${iconHover} ${
          sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
            ? scrollPosition > 120
              ? "fixed"
              : ""
            : ""
        }`}
      >
        <PerfectScrollbar className="deznav-scroll">
          <MM className="metismenu" id="menu">
            {(currentUser.UserTypeID === 1 ||
              currentUser.UserTypeID === 2 ||
              currentUser.UserTypeID === 8) && (
              <li className={`${deshBoard.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  <i className="flaticon-025-dashboard"></i>
                  <span className="nav-text">Dashboard</span>
                </Link>

                <ul>
                  <li>
                    <Link
                      className={`${path === "" ? "mm-active" : "dashboard"}`}
                      to="/dashboard"
                    >
                      Main Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "" ? "mm-active" : "order-dashboard"
                      }`}
                      to="/order-dashboard"
                    >
                      Order Dashboard
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {currentUser.UserTypeID !== 4 &&
              currentUser.UserTypeID !== 5 &&
              currentUser.UserTypeID !== 6 &&
              currentUser.UserTypeID !== 7 && (
                <li className={`${Products.includes(path) ? "mm-active" : ""}`}>
                  <Link className="has-arrow ai-icon" to="#">
                    <i className="flaticon-017-clipboard"></i>
                    <span className="nav-text">Products</span>
                  </Link>

                  <ul>
                    <li>
                      <Link
                        className={`${
                          path === "ProductList" ? "mm-active" : ""
                        }`}
                        to="/ProductList"
                      >
                        Product Details
                      </Link>
                    </li>
                    {currentUser?.UserTypeID !== 3 && (
                      <li>
                        <Link
                          className={`${
                            path === "ProductReports" ? "mm-active" : ""
                          }`}
                          to="/ProductReports"
                        >
                          Product Report
                        </Link>
                      </li>
                    )}

                    {(currentUser?.UserTypeID === 1 ||
                      currentUser?.UserTypeID === 8 ||
                      currentUser?.UserTypeID === 2) && (
                      <>
                        <li>
                          <Link
                            className={`${
                              path === "archiveProducts" ? "mm-active" : ""
                            }`}
                            to="/archiveProducts"
                          >
                            Archive Products
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={`${
                              path === "TransactionProductReport"
                                ? "mm-active"
                                : ""
                            }`}
                            to="/TransactionProductReport"
                          >
                            Transaction Product Report
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={`${
                              path === "ProductExpirationReport"
                                ? "mm-active"
                                : ""
                            }`}
                            to="/ProductExpirationReport"
                          >
                            Product Expiration
                          </Link>
                        </li>

                        <li>
                          <Link
                            className={`${
                              path === "TransactionReport" ? "mm-active" : ""
                            }`}
                            to="/TransactionReport"
                          >
                            Transaction Report
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </li>
              )}

            {currentUser.UserTypeID !== 5 &&
              currentUser.UserTypeID !== 6 &&
              currentUser.UserTypeID !== 7 && (
                <li className={`${order.includes(path) ? "mm-active" : ""}`}>
                  <Link className="has-arrow ai-icon" to="#">
                    <i className="fas fa-dolly"></i>
                    <span className="nav-text forms">Order</span>
                  </Link>
                  <ul>
                    <li>
                      <Link
                        className={`${
                          path === "order-list" ? "mm-active" : ""
                        }`}
                        to="/OrderList"
                      >
                        Order List
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "Skidbarcode-generate" ? "mm-active" : ""
                        }`}
                        to="/SkidbarcodeGenerate"
                      >
                        Skid Barcode Generate
                      </Link>
                    </li>
                    {(currentUser.UserTypeID === 2 ||
                      currentUser.UserTypeID === 1) && (
                      <li>
                        <Link
                          className={`${
                            path === "AuditTrailReport" ? "mm-active" : ""
                          }`}
                          to="/AuditTrailReport"
                        >
                          Audit Trail Report
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
            {(currentUser.UserTypeID === 8 ||
              currentUser.UserTypeID === 6 ||
              currentUser.UserTypeID === 5 ||
              currentUser.UserTypeID === 4 ||
              currentUser.UserTypeID === 3 ||
              currentUser.UserTypeID === 2 ||
              currentUser.UserTypeID === 1) && (
              <li className={`${inventory.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon">
                  <i className="fas fa-boxes"></i>
                  <span className="nav-text forms">Inventory</span>
                </Link>
                <ul>
                  <li></li>
                  {(currentUser?.UserTypeID === 1 ||
                    currentUser?.UserTypeID === 2 ||
                    currentUser?.UserTypeID === 5 ||
                    currentUser?.UserTypeID === 6 ||
                    currentUser?.UserTypeID === 8) && (
                    <li>
                      <Link
                        className={`${
                          path === "StockManagement" ? "mm-active" : ""
                        }`}
                        to="/StockManagement"
                      >
                        Stock Management
                      </Link>
                    </li>
                  )}

                  <li>
                    <Link
                      className={`${
                        path === "BulkInventory" ? "mm-active" : ""
                      }`}
                      to="/BulkInventory"
                    >
                      Bulk Inventory
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "MRHistoryReport" ? "mm-active" : ""
                      }`}
                      to="/MRHistoryReport"
                    >
                      MR History Report
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "MRDiscrepancyReport" ? "mm-active" : ""
                      }`}
                      to="/MRDiscrepancyReport"
                    >
                      MR Discrepancy Report
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "MRPurchaseOrderReport" ? "mm-active" : ""
                      }`}
                      to="/MRPurchaseOrderReport"
                    >
                      MR Purchase Order Report
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            {currentUser.UserTypeID !== 4 &&
              currentUser.UserTypeID !== 3 &&
              currentUser.UserTypeID !== 5 &&
              currentUser.UserTypeID !== 6 &&
              currentUser.UserTypeID !== 7 && (
                <li className={`${user.includes(path) ? "mm-active" : ""}`}>
                  <Link className="has-arrow ai-icon" to="#">
                    <i className="flaticon-043-menu"></i>
                    <span className="nav-text">Users</span>
                  </Link>
                  <ul>
                    <li>
                      <Link
                        className={`${path === "UserList" ? "mm-active" : ""}`}
                        to="/UserList"
                      >
                        Manage User
                      </Link>
                    </li>

                    <li>
                      <Link
                        className={`${
                          path === "VendorList" ? "mm-active" : ""
                        }`}
                        to="/VendorList"
                      >
                        Manage Vendor
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "ClientList" ? "mm-active" : ""
                        }`}
                        to="/ClientList"
                      >
                        Manage Client
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
            {currentUser.UserTypeID !== 4 &&
              currentUser.UserTypeID !== 3 &&
              currentUser.UserTypeID !== 5 &&
              currentUser.UserTypeID !== 6 &&
              currentUser.UserTypeID !== 7 && (
                <li className={`${master.includes(path) ? "mm-active" : ""}`}>
                  <Link className="has-arrow ai-icon" to="#">
                    <i className="flaticon-022-copy"></i>
                    <span className="nav-text">Master</span>
                  </Link>
                  <ul>
                    <li>
                      <Link
                        className={`${
                          path === "" ? "mm-active" : "CategoriesList"
                        }`}
                        to="/CategoriesList"
                      >
                        Categories
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "SubCategories" ? "mm-active" : ""
                        }`}
                        to="/SubCategories"
                      >
                        Sub Categories
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "Attributes" ? "mm-active" : ""
                        }`}
                        to="/Attributes"
                      >
                        Attributes
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${path === "Terms" ? "mm-active" : ""}`}
                        to="/Terms"
                      >
                        Terms
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${path === "Warehouse" ? "mm-active" : ""}`}
                        to="/Warehouse"
                      >
                        Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "CourierType" ? "mm-active" : ""
                        }`}
                        to="/CourierType"
                      >
                        Courier Type
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
            {(currentUser?.UserTypeID === 1 ||
              currentUser?.UserTypeID === 7) && (
              <li className={`${settings.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="/ProductStock">
                  <i className="flaticon-017-clipboard"></i>
                  <span className="nav-text">Accountant</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      className={`${
                        path === "ProductStock" ? "mm-active" : ""
                      }`}
                      to="/ProductStock"
                    >
                      Product Stock Report
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            <li className={`${settings.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-013-checkmark"></i>
                <span className="nav-text">Settings</span>
              </Link>
              <ul>
                <li>
                  <Link
                    className={`${
                      path === "ChangePassword" ? "mm-active" : ""
                    }`}
                    to="/ChangePassword"
                  >
                    Change Password
                  </Link>
                </li>
                {(currentUser?.UserTypeID === 1 ||
                  currentUser?.UserTypeID === 2) && (
                  <li>
                    <Link
                      className={`${
                        path === "AdminPasscodeSettings" ? "mm-active" : ""
                      }`}
                      to="/AdminPasscodeSettings"
                    >
                      Admin Passcode
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          </MM>
        </PerfectScrollbar>
      </div>
    </div>
  );
};

export default SideBar;
